import { Component, input } from '@angular/core';
import { ComponentSize } from '../types';

@Component({
  selector: 'app-card',
  imports: [],
  template: `
    <div [class]="cardClasses">
      @if (header()) {
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">{{ header() }}</h3>
        </div>
      }
      <div [class]="contentClasses">
        <ng-content></ng-content>
      </div>
      @if (footer()) {
        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <ng-content select="[footer]"></ng-content>
        </div>
      }
    </div>
  `,
  styles: []
})
export class CardComponent {
  header = input<string>('');
  footer = input<boolean>(false);
  padding = input<ComponentSize>('md');
  shadow = input<boolean>(true);
  bordered = input<boolean>(true);
  hoverable = input<boolean>(false);

  get cardClasses(): string {
    const classes = [
      'bg-white',
      'dark:bg-gray-800',
      'rounded-lg',
      'transition-all',
      'duration-200'
    ];

    if (this.shadow()) {
      classes.push('shadow-md', 'hover:shadow-lg');
    }

    if (this.bordered()) {
      classes.push('border', 'border-gray-200', 'dark:border-gray-700');
    }

    if (this.hoverable()) {
      classes.push('hover:scale-[1.01]', 'cursor-pointer');
    }

    return classes.join(' ');
  }

  get contentClasses(): string {
    const paddingMap = {
      xs: 'px-3 py-2',
      sm: 'px-4 py-3',
      md: 'px-6 py-4',
      lg: 'px-8 py-6',
      xl: 'px-10 py-8'
    };
    return paddingMap[this.padding()];
  }
}

